/**
 * 运营系统相关路由
 * coreCarRouter 核心车主相关路由
 */
import Layout from '@/layout'

// 核心车主相关路由
const coreCarRouter = {
	STANDARD_CONFIGURATION_MENU: () =>
		import('@/views/operating/driver-core/standard-configuration/index') //达标配置
}

const operationRouter = {
	PriceNotice: () => import('@/views/operating/price-notice/index'),
	BOOKING_BUDGET_CHANGE_MENU: () => import('@/views/operating/order-hx-immediate/index'),
	MESSAGE_CENTER_SMS_TEMPLATE: () =>
		import('@/views/operations-system/message-center/sms-template/index'), // 短信模板
	...coreCarRouter
}

const operationRouters = []
export { operationRouter, operationRouters }
